import request from '../../utils/request'

// 获取分页

export function getServiesList(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/page',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

export function getMyServiesList(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/myPage',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}
// 申请服务

export function applyServies(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/apply',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}
// 查看详情

export function getServiesDetail(id) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/detail',
    method: 'get',
    params: id,
    headers: {
      isToken: true
    }
  })
}

// 删除
export function deleteServies(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/delete',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}
// 审核
export function auditServies(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/audit',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}
export function uploaddwzzFile(data) {
  return request({
    headers: {
      'Content-Type': 'multipart/form-data',
      isToken: true
    },
    url: '/sc/ticketMain/api/factFwjbxxb/uploadFwzzFile',
    method: 'post',
    params: data
  })
}

// 获取所有的市/获取机构类型

export function getAllCityList(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/selectFwlxList',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 获取数据

export function getNumList(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/fwztNumStatistics',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 查询机构的服务挂载机构
export function getMountJg(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/getMountJg',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 查询可选择的服务类型
export function getFwlxDictList(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/getFwlxDictList',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}
